import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "@/context/ContentContext";
import { AuthProvider } from "@/context/AuthContext";
import { ServerStatusProvider } from "@/context/ServerStatusContext";
import { SiteLayout } from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Novidades from "@/pages/Novidades";
import Regras from "@/pages/Regras";
import Informacoes from "@/pages/Informacoes";
import Loja from "@/pages/Loja";
import Precario from "@/pages/Precario";
import EditPrecario from "@/pages/admin/EditPrecario";
import NotFound from "@/pages/NotFound";
import GestaoLogin from "@/pages/admin/GestaoLogin";
import GestaoLayout from "@/pages/admin/GestaoLayout";
import EditInicio from "@/pages/admin/EditInicio";
import EditTextos from "@/pages/admin/EditTextos";
import EditTema from "@/pages/admin/EditTema";
import EditManutencao from "@/pages/admin/EditManutencao";
import EditCandidaturas from "@/pages/admin/EditCandidaturas";
import Candidatura from "@/pages/Candidatura";
import EditInformacoes from "@/pages/admin/EditInformacoes";
import EditLoja from "@/pages/admin/EditLoja";
import EditComunidade from "@/pages/admin/EditComunidade";
import EditLigacoes from "@/pages/admin/EditLigacoes";
import EditMedia from "@/pages/admin/EditMedia";
import EditRegras from "@/pages/admin/EditRegras";
import EditConta from "@/pages/admin/EditConta";
import EditEquipa from "@/pages/admin/EditEquipa";
import EditAtividade from "@/pages/admin/EditAtividade";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <Routes>
            <Route element={<ServerStatusProvider><SiteLayout /></ServerStatusProvider>}>
              <Route path="/" element={<Home />} />
              <Route path="/novidades" element={<Novidades />} />
              <Route path="/regras" element={<Regras />} />
              <Route path="/regras/:slug" element={<Regras />} />
              <Route path="/informacoes" element={<Informacoes />} />
              <Route path="/candidatura" element={<Candidatura />} />
              <Route path="/loja" element={<Loja />} />
              <Route path="/precario" element={<Precario />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/gestao" element={<GestaoLogin />} />
            <Route element={<GestaoLayout />}>
              <Route path="/gestao/inicio" element={<EditInicio />} />
              <Route path="/gestao/textos" element={<EditTextos />} />
              <Route path="/gestao/tema" element={<EditTema />} />
              <Route path="/gestao/manutencao" element={<EditManutencao />} />
              <Route path="/gestao/candidaturas" element={<EditCandidaturas />} />
              <Route path="/gestao/informacoes" element={<EditInformacoes />} />
              <Route path="/gestao/comunidade" element={<EditComunidade />} />
              <Route path="/gestao/loja" element={<EditLoja />} />
              <Route path="/gestao/precario" element={<EditPrecario />} />
              <Route path="/gestao/ligacoes" element={<EditLigacoes />} />
              <Route path="/gestao/media" element={<EditMedia />} />
              <Route path="/gestao/regras" element={<EditRegras />} />
              <Route path="/gestao/conta" element={<EditConta />} />
              <Route path="/gestao/equipa" element={<EditEquipa />} />
              <Route path="/gestao/atividade" element={<EditAtividade />} />
              <Route path="/gestao/*" element={<Navigate to="/gestao/inicio" replace />} />
            </Route>
          </Routes>
          <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#121418", border: "1px solid #272A34", color: "#F4F4F5" } }} />
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
